import Storage from './storage';

// class token
class Token {
	constructor() {
		this._accessToken = null;
		this._refreshToken = null;
	}

	async get() {
		if (this._accessToken) {
			return Promise.resolve({
				accessToken: this._accessToken,
				refreshToken: this._refreshToken,
			});
		}

		const tokens = await Storage.getItem('token');
		if (!tokens) return null;

		const [accessToken, refreshToken] = tokens.split('$');
		this._accessToken = accessToken;
		this._refreshToken = refreshToken;

		return Promise.resolve({ accessToken, refreshToken });
	}

	async set(accessToken, refreshToken) {
		this._accessToken = accessToken;
		this._refreshToken = refreshToken;
		try {
			await Storage.setItem('token', `${accessToken}$${refreshToken}`);
			return true;
		} catch (e) {
			return false;
		}
	}

	clear() {
		this._accessToken = null;
		this._refreshToken = null;
		return Storage.removeItem('token');
	}
}

export default new Token();
